( function ( $ ) {

	MP.intro_height = function(){

		var intros = document.querySelectorAll('.m-intro'),
			introWrapper = document.querySelectorAll('.m-intro-wrapper');

		var header = document.getElementById('site-top') || document.createElement('div');

		introWrapper.length && [].forEach.call ( introWrapper , function( el ){

			lib.on( ['load','resize'] , function(){
				
				el.style.height = lib.viewport().height - lib.offset( '#wpadminbar') + 'px';

			});			

		});

		var header_componsate = document.querySelectorAll('.header-componsate');

		header_componsate.length && [].forEach.call ( header_componsate , function( el ){
			lib.on( ['load','resize','scroll'] ,function(){
				el.style.paddingTop = header.offsetHeight + 'px';				
			},800);
		});

		window.addEventListener('load',function(){
			document.body.classList.remove( 'smooth-loading' );
			document.body.classList.add( 'is-rendered' );			
		});

	};

	MP.intro_sections_height = function(){

		var sections = document.querySelectorAll('.scrolling-menu-section');

		if ( !sections.length ) return;

		[].forEach.call ( sections , function(sect){
			
			sect.className += ' l-flex f-c';

			var height_setter = document.createElement('div');

			sect.appendChild( height_setter );

			lib.on('resize',function(){

				if ( lib.viewport().width > mobile ) {
					
					height_setter.style.height = 
						lib.viewport().height - lib.offset('#wpadminbar') - ( lib.compute_style( sect , 'padding-top' , true ) * 2 ) + 'px';
				
				}

			});

		});

	};

	MP.scroll_to_anchor = function(){

		var btns = document.querySelectorAll('.btn-scroll-to-anchor');

		if ( ! btns ) return;
		[].forEach.call( btns , function( btn ){
 
			btn.addEventListener('click', function(e){
				
				var anchor = btn.hash,
					element = document.getElementById(anchor.replace('#',''));
				
				if ( ! element ) return;

				var formula = window.pageYOffset + element.getBoundingClientRect().top ;
				
				e.preventDefault();

				$('body,html').animate({
					scrollTop:formula - lib.offset('#wpadminbar,#site-top')
				},800,function(){
					$('body,html').animate({
						scrollTop:formula - lib.offset('#wpadminbar,#site-top')
					},100);		
				});

			});
		});
	};

	MP.mobile_intro_price = function(){
		if( lib.viewport().width <= 750 ){
			var start_btn = $('.intro-link');
			$('h1.intro-title').wrap("<div class='mobile-h1-wrap'></div>");
			if( ! start_btn ) return;

			var new_price_group = $('.mobile-h1-wrap');
			new_price_group.append(start_btn); 
		}
	};


}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/m-intro.js